import { Button, Typography } from '@mgmresorts/wcl-lab';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function CTASection() {
  const { processAccountSetup, isLoading, canProcessAccountSetup } = useContext(MlifeAccountSetupContext);
  const { getContentByPath } = useContent();

  return (
    <Button
      sticky
      testId='mlifeActivation-cta'
      ariaLabel={getContentByPath('mlifeActivation.accountSetupSection.ctaSection.label')}
      disabled={isLoading || !canProcessAccountSetup}
      onClick={processAccountSetup}
      onKeyPress={e => {
        e.preventDefault();
        if (e.key === 'Enter') {
          processAccountSetup();
        }
      }}
      className='identity__form-submit'
      loading={isLoading}
    >
      <Typography>{getContentByPath('mlifeActivation.accountSetupSection.ctaSection.title')}</Typography>
    </Button>
  );
}

CTASection.displayName = 'CTASectionField';
